import type { Trip } from '@/services/trips';

const COMPLETED_TRIP_STATUSES = new Set(['completed', 'complete', 'finished', 'done', 'past']);

export const isTripCompleted = (trip: Trip): boolean => {
  // Treat trip end dates as inclusive (end-of-day). Many trips store date-only values (midnight),
  // so comparing raw `endDate < now` would mark trips completed too early (and hides them from "current" views).
  const end = trip.endDate instanceof Date ? new Date(trip.endDate) : new Date(trip.endDate as any);
  if (!Number.isFinite(end.getTime())) {
    return false;
  }
  end.setHours(23, 59, 59, 999);
  if (end < new Date()) {
    return true;
  }
  if (!trip.status) {
    return false;
  }
  return COMPLETED_TRIP_STATUSES.has(trip.status.trim().toLowerCase());
};

/** Active trips users can still add items to (not archived, not past end date). */
export const isTripActive = (trip: Trip): boolean => {
  return !trip.isArchived && !isTripCompleted(trip);
};






